
import Util from 'service/util'

import MessageCustomerVehicle from 'view/op/messages/MessageCustomerVehicle'

const MessageCustomerDetail = ({
  uid, contacts, vehicles, bills
}) =>
{
  return (
    <div className="message-customer-detail">
      <table>
        <tbody>
          <tr>
            <th>客戶編號</th>
            <td>{ uid }</td>
          </tr>
          { contacts.map( c =>
            <tr key={`${uid}-${c.c_num}`}>
              <th>{ Util.getContactType(c.c_type) }</th>
              <td>{ c.c_num }</td>
            </tr>
          )}
        </tbody>
      </table>

      { vehicles.map( v => 
        <MessageCustomerVehicle key={v.cd_license} {...v} />
      )}
    </div>
  )
}

export default MessageCustomerDetail
